import React from "react";

// ============================================================
// FYUNOR — Theme bootstrap
// Applies the stored (or system-preferred) colour scheme before
// paint, avoiding a flash of the wrong theme.
// ============================================================

export function useThemeBootstrap() {
  React.useEffect(() => {
    const root = document.documentElement;
    const stored = (() => {
      try { return localStorage.getItem("fyunor-theme"); } catch { return null; }
    })();
    // Light is the default for first-time visitors. A saved preference
    // always wins; the OS theme is never followed automatically.
    const isDark = stored ? stored === "dark" : false;
    root.classList.toggle("dark", isDark);
  }, []);
}